/**
 * Shared plumbing for the service configuration pages. Each sub-component
 * emits a full estimate line keyed by `key`; the page collects them, totals
 * them and pushes them into the estimate on "Add to estimate".
 */
export const configurable = {
  data() {
    return {
      configurations: {},
    };
  },
  computed: {
    /** Only lines that actually cost something (or need a quote) are added. */
    lines() {
      return Object.values(this.configurations).filter(
        (line) =>
          line && (line.monthlyCost > 0 || line.onRequest || line.dynamic)
      );
    },
    monthlyCost() {
      return this.lines.reduce((total, line) => total + (line.monthlyCost || 0), 0);
    },
    totalCost() {
      return this.monthlyCost * 12;
    },
    canAdd() {
      return this.lines.length > 0;
    },
  },
  methods: {
    receiveConfig(line) {
      if (!line || !line.key) return;
      this.configurations = { ...this.configurations, [line.key]: line };
    },
    dropConfig(key) {
      if (!(key in this.configurations)) return;
      const next = { ...this.configurations };
      delete next[key];
      this.configurations = next;
    },
    addLines() {
      if (!this.lines.length) return;
      this.lines.forEach((line) => {
        this.$store.commit("services/ADD_SERVICE", line);
      });
      this.$router.push("/summary");
    },
  },
};
